module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv1_logo_v2_1.cc365fa00d80c3dc6f49bdfdff54ac87.png";